import React, { useState, useEffect } from 'react'
import {
   makeStyles,
   Popover,
   Grid,
   Typography,
   Tooltip
} from '@material-ui/core'
import VpnKeyIcon from '@material-ui/icons/VpnKey'
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined'
import DoneOutlinedIcon from '@material-ui/icons/DoneOutlined'

const useStyles = makeStyles(theme => ({
   codeContainer: {
      display: 'flex',
      padding: theme.spacing(2)
   },
   copyButton: {
      cursor: 'pointer'
   },
   doneButton: {
      color: '#3264DC'
   },
   buttonContainer: {
      marginLeft: theme.spacing(1),
      height: 20,
      width: 20
   }
}))

function TableActionPopover({ data }) {
   const classes = useStyles()
   const [anchorEl, setAnchorEl] = useState(null)
   const [isCopied, setIsCopied] = useState(false)

   const open = Boolean(anchorEl)
   const id = open ? 'simple-popover' : undefined

   function handleOpen(event) {
      setAnchorEl(event.currentTarget)
      return false
   }

   function handleClose() {
      setAnchorEl(null)
   }

   function copyToClipboard() {
      navigator.clipboard.writeText(data.toString().trim())
      setIsCopied(true)
      return false
   }

   useEffect(() => {
      let tooltipTimeout = null
      if (isCopied) {
         tooltipTimeout = setTimeout(() => setIsCopied(false), 3000)
      }
      return () => {
         clearTimeout(tooltipTimeout)
      }
   }, [isCopied])

   return (
      <div>
         <VpnKeyIcon fontSize="small" onClick={handleOpen} />
         <Popover
            id={id}
            open={open}
            anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
            transformOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            anchorEl={anchorEl}
            onClose={handleClose}
            onClick={() => false}
         >
            <Grid className={classes.codeContainer}>
               <Typography>{data}</Typography>
               <Tooltip title="¡Copiado!" open={isCopied} placement="top" arrow>
                  <div className={classes.buttonContainer}>
                     {isCopied ? (
                        <DoneOutlinedIcon
                           fontSize="small"
                           className={classes.doneButton}
                        />
                     ) : (
                        <Tooltip title="Copiar" placement="top" arrow>
                           <FileCopyOutlinedIcon
                              fontSize="small"
                              className={classes.copyButton}
                              onClick={copyToClipboard}
                           />
                        </Tooltip>
                     )}
                  </div>
               </Tooltip>
            </Grid>
         </Popover>
      </div>
   )
}

export default TableActionPopover
